module.exports = __webpack_public_path__ + "img/پنج-ضلعی.a42696f8.png";